import { render, staticRenderFns } from "./EmployeePlacementData.vue?vue&type=template&id=60817108&scoped=true&"
import script from "./EmployeePlacementData.vue?vue&type=script&lang=js&"
export * from "./EmployeePlacementData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60817108",
  null
  
)

export default component.exports